"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  login: 'Login',
  logout: 'Logout',
  none: 'None',
  undefined: 'Undefined',
  product_categories: 'Product Categories',
  all_categories: 'All Categories',
  sort: 'Sort',
  select: 'Select',
  keyword: 'Keyword',
  list: 'List',
  order_id: 'Order ID',
  order_created: 'Order Created',
  order_content: 'Order Content',
  pieces_of_item: 'Pieces of item',
  cart_items: 'Cart Items',
  item: 'Item',
  spec: 'Specification',
  total: 'Total',
  subtotal: 'Subtotal',
  price_info: 'Price information',
  product: 'Product',
  fee: 'Logistic Fee',
  discount: 'Discount',
  order_info: 'Order information',
  order_status: 'Order status',
  order_note: 'Order note',
  order_total: 'Order total',
  order_quantity: 'Quantity',
  payment_type: 'Payment type',
  payment_status: 'Payment status',
  buyer_info: 'Buyer information',
  buyer_name: 'Buyer name',
  buyer_phone: 'Buyer phone',
  buyer_email: 'Buyer email',
  buyer_address: 'Buyer address',
  buyer_tel: 'Buyer telephone',
  buyer_tel_ext: 'Buyer telephone extension number'
};
exports.labels = labels;